import React, { useEffect, useState } from "react";
import { Input, Checkbox, message, Modal, Form, Button, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";

import drEasyApi, { setApiSlug } from "../../Api/Customapi";
import { HiOutlineCheck, HiOutlineMail, HiOutlineUser } from "react-icons/hi";
import { GiPadlock, GiPhone } from "react-icons/gi";
import ForgotPasswordModal from "../Modals/ForgotPasswordModal";
import VerificationModal from "../Modals/VerificationModal";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import { useLanguage } from "../../context/LanguageContext";
import { Radio } from "antd";
import LanguageSwitcher from "../Ui/LanguageSwitcher";
import { BiArrowBack, BiArrowFromRight } from "react-icons/bi";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function LoginModal({
  setRegisterModal,
  loginModal,
  setLoginModal,
  isRegister,
}) {
  const [loginForm] = Form.useForm();
  const [signupForm] = Form.useForm();
  const { t, isRTL, i18n } = useLanguage();

  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [shake, setShake] = useState(false);
  const [activeTab, setActiveTab] = useState(isRegister ? "signup" : "login");

  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [verificationEmail, setVerificationEmail] = useState("");
  const [verificationLoading, setVerificationLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(60);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotStep, setForgotStep] = useState(1);
  const [resetCode, setResetCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  // Store signup token for auto-login after verification
  const [signupToken, setSignupToken] = useState("");

  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("docTkn");
  }, []);
  useEffect(() => {
    setActiveTab(isRegister ? "signup" : "login");
  }, [isRegister, loginModal]);

  useEffect(() => {
    setApiSlug(slug);
  }, [slug]);

  // Cooldown timer for resend button
  useEffect(() => {
    if (resendCooldown > 0) {
      const timer = setTimeout(
        () => setResendCooldown(resendCooldown - 1),
        1000,
      );
      return () => clearTimeout(timer);
    }
  }, [resendCooldown]);

  // Clear forms when switching tabs
  useEffect(() => {
    loginForm.resetFields();
    signupForm.resetFields();
  }, [activeTab, loginForm, signupForm]);
  const { Option } = Select;

    const handleLogin = async (values) => {
        setLoading(true);
        try {
            console.log("Starting login process");

            const endpoint = `/api/${slug}/User/Login`;
            const payload = { email: values.email, password: values.password };

            console.log("API endpoint:", endpoint);
            const response = await drEasyApi.post(endpoint, payload);
            console.log("API response:", response);

            const { token, role } = response.data;

            if (role !== 1) {
                message.error("Unauthorized access.");
                return;
            }

            // Store token based on remember me option
            const storage = rememberMe ? localStorage : sessionStorage;
            storage.setItem(`userTkn-${slug}`, token);

     setLoginSuccess(true);
      setTimeout(() => {
        setLoginModal(false);
        setLoginSuccess(false);
      }, 700);
            navigate(`/${slug}/home`);

        } catch (error) {
            triggerErrorAnimation();

            if (error.response?.status === 401 || error.response?.status === 400) {
                const errorMessage = error.response?.data?.message || error.response?.data?.errors?.[0] || "";

                // Check if error is related to verification
                if (errorMessage.toLowerCase().includes("verify")) {
                    message.error("Please verify your email before logging in.");
                    setVerificationEmail(values.email);
                    setShowVerificationModal(true);
                    setResendCooldown(60)
                } else if (errorMessage.toLowerCase().includes("login invalid")) {
                    message.error("Invalid email or password");
                } else {
                    console.log(error);
                    message.error(errorMessage);
                }
            } else if (error.response?.data?.errors) {
                message.error(error.response.data.errors[0]);
            } else {
                message.error("Login failed. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSignup = async (values) => {
        setLoading(true);
        try {
            console.log("Starting registration process");

            const endpoint = `/api/${slug}/User/RegisterAsUser`;
            const payload = {
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                phoneNumber: values.phoneNumber,
                password: values.password
            };

            console.log("API endpoint:", endpoint);
            const response = await drEasyApi.post(endpoint, payload);
            console.log("API response:", response);

            const { token } = response.data;
            setSignupToken(token);

            message.success("Registration successful! Please check your email for verification code.");
            setVerificationEmail(values.email);
            setShowVerificationModal(true);
            setResendCooldown(60)

            signupForm.resetFields();

     } catch (error) {
      triggerErrorAnimation();

      if (error.response?.status === 401 || error.response?.status === 400) {
        const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.errors?.[0] ||
          "";

        if (errorMessage.toLowerCase().includes("already exist")) {
          Modal.confirm({
            title: isRTL
              ? "⚠️ هذا البريد الإلكتروني مسجل مسبقاً"
              : "⚠️ Email Already Registered",
            content: isRTL
              ? `البريد الإلكتروني "${values.email}" مرتبط بحساب موجود بالفعل. هل تريد تسجيل الدخول بدلاً من ذلك؟`
              : `The email "${values.email}" is already linked to an existing account. Would you like to log in instead?`,
            okText: isRTL ? "تسجيل الدخول" : "Log In",
            cancelText: isRTL ? "إلغاء" : "Cancel",
            okButtonProps: {
              style: {
                backgroundColor: "var(--primary, #0d9488)",
                borderColor: "var(--primary, #0d9488)",
              },
            },
            onOk: () => {
              setActiveTab("login");
              setTimeout(() => {
                loginForm.setFieldsValue({ email: values.email });
              }, 100);
            },
          });
        } else {
          message.error(errorMessage);
        }
      } else if (error.response?.data?.errors) {
        message.error(error.response.data.errors[0]);
      } else {
        message.error(t("auth.registrationFailed"));
      }
    } finally {
      setLoading(false);
    }
    };

    const handleVerifyCode = async () => {
        if (!verificationCode.trim()) {
            message.warning("Please enter the verification code.");
            return;
        }

        setVerificationLoading(true);
        try {
            const res = await drEasyApi.post(`/api/${slug}/User/Verify`, {
                email: verificationEmail,
                otpCode: verificationCode
            });
            const { token, role } = res.data;

            message.success("Email verified successfully! Logging you in...");

            // Auto-login after successful verification
            if (token) {
                // Store the token
                const storage = rememberMe ? localStorage : sessionStorage;
                storage.setItem(`userTkn-${slug}`, token);

                navigate(`/${slug}/home`);
            } else {
                setShowVerificationModal(false);
                setActiveTab("login");
            }

            setVerificationCode("");
            setSignupToken("");
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.response?.data?.errors?.[0] || "Verification failed. Please try again.";
            message.error(errorMessage);
        } finally {
            setVerificationLoading(false);
        }
    };

    const handleResendCode = async () => {
        setVerificationCode("")
        setResendLoading(true);
        try {
            await drEasyApi.post(`/api/${slug}/User/ResendOtp`, {
                email: verificationEmail
            });

            message.success("Verification code sent to your email!");
            setResendCooldown(60);
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.response?.data?.errors?.[0] || "Failed to resend code. Please try again.";
            message.error(errorMessage);
        } finally {
            setResendLoading(false);
        }
    };

    const triggerErrorAnimation = () => {
        setShake(true);
        setTimeout(() => setShake(false), 400);
    };

    const handleGoogleSignIn = async (response) => {
        try {
            console.log("Google Sign-In response:", response);

            // Send the Google ID token to your backend
            const apiResponse = await drEasyApi.post(`/api/${slug}/User/GoogleAuth`, {
                token: response.credential // This is the ID token (JWT)
            });

            console.log("Google Auth API response:", apiResponse);

            const { token, role } = apiResponse.data;

            // Validate if the role is 1 (user)
            if (role !== 1) {
                message.error("Unauthorized access.");
                return;
            }

            // Store token based on remember me option
            const storage = rememberMe ? localStorage : sessionStorage;
            storage.setItem(`userTkn-${slug}`, token);

            message.success("Google Sign-In successful!");
            navigate(`/${slug}/home`);

        } catch (error) {
            console.error("Google Sign-In error:", error);

            if (error.response?.status === 401 || error.response?.status === 400) {
                const errorMessage = error.response?.data?.message || error.response?.data?.errors?.[0] || "";
                message.error(errorMessage || "Google Sign-In failed. Please try again.");
            } else if (error.response?.data?.errors) {
                message.error(error.response.data.errors[0]);
            } else {
                message.error("Google Sign-In failed. Please try again.");
            }
        }
    };
    const handleResendResetCode = async () => {

        try {
            await drEasyApi.post(`/api/${slug}/User/ForgotPassword`, {
                email: forgotEmail
            });
            message.success("Reset code sent to your email.");
        } catch (err) {
            if (err.response?.data.errors[0].includes("not found")) {
                message.error("Your email not found, you need to Signup");
            } else {
                message.error(err.response?.data.errors[0] || "Failed to send reset email.");
            }
            throw err; // Re-throw to handle in modal
        }
    };

  const renderLoginForm = () =>
    loginSuccess ? (
      <div className="text-center py-8">
        <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
          <HiOutlineCheck className="text-white text-xl" />
        </div>
        <h2 className="text-xl font-semibold text-textPrimary">
          {t("auth.loginSuccess")}
        </h2>
        {/* <p className="text-gray-500 mt-2">{t("auth.redirecting")}</p> */}
      </div>
    ) : (
      <Form
        form={loginForm}
        layout="vertical"
        onFinish={handleLogin}
        className="space-y-4"
        size="large"
      >
        <Form.Item
          name="email"
          label={
            <span className="text-textPrimary text-lg">{t("auth.email")}</span>
          }
          rules={[
            {
              required: true,
              message: t("auth.emailRequired"),
            },
            {
              type: "email",
              message: t("auth.emailInvalid"),
            },
          ]}
        >
          <Input
            placeholder={t("auth.emailPlaceholder")}
            prefix={<HiOutlineMail className="text-placeHolder" />}
            className="text-placeHolder placeholder:text-placeHolder"
          />
        </Form.Item>

        <Form.Item
          name="password"
          label={
            <span className="text-textPrimary text-lg">
              {t("auth.password")}
            </span>
          }
          rules={[
            {
              required: true,
              message: t("auth.passwordRequired"),
            },
          ]}
        >
          <Input.Password
            placeholder={t("auth.passwordPlaceholder")}
            prefix={<GiPadlock className="text-placeHolder" />}
            className="text-placeHolder placeholder:text-placeHolder"
          />
        </Form.Item>

        <div className="flex items-center justify-between">
          <Checkbox
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            className="text-primary text-lg"
          >
            {t("auth.rememberMe")}
          </Checkbox>
          <span
            className="text-secondary text-lg cursor-pointer hover:underline"
            onClick={() => {
              setForgotStep(1);
              setForgotEmail("");
              setResetCode("");
              setNewPassword("");
              setShowForgotModal(true);
              setResendCooldown(60);
            }}
          >
            {t("auth.forgotPassword")}
          </span>
        </div>

        <Button
          type=""
          htmlType="submit"
          loading={loading}
          className="w-full py-3 h-auto text-lg text-white font-semibold bg-primary hover:bg-primary_hover border-none"
        >
          {loading ? t("auth.loggingIn") : t("auth.confirmLogin")}
        </Button>
        <p className="text-center text-sm text-gray-500 mt-4">
          {t("auth.noAccount")}{" "}
          <span
            className="text-primary font-semibold cursor-pointer hover:underline"
            onClick={() => setActiveTab("signup")}
          >
            {t("auth.registerNow")}
          </span>
        </p>
      </Form>
    );

  const renderSignupForm = () => (
    <Form
      form={signupForm}
      layout="vertical"
      onFinish={handleSignup}
      className="space-y-4"
      size="large"
    >
      {/* Row 1: Name */}
      <div className="flex gap-4">
        <Form.Item
          name="firstName"
          label={
            <span className="text-textPrimary text-lg">
              {t("auth.firstName")}
            </span>
          }
          className="flex-1 mb-0"
          rules={[
            { required: true, message: t("auth.firstNameRequired") },
            { min: 2, message: t("auth.firstNameMin") },
          ]}
        >
          <Input
            placeholder={t("auth.firstNamePlaceholder")}
            prefix={<HiOutlineUser className="text-placeHolder" />}
          />
        </Form.Item>

        <Form.Item
          name="lastName"
          label={
            <span className="text-textPrimary text-lg">
              {t("auth.lastName")}
            </span>
          }
          className="flex-1 mb-0"
          rules={[
            { required: true, message: t("auth.lastNameRequired") },
            { min: 2, message: t("auth.lastNameMin") },
          ]}
        >
          <Input
            placeholder={t("auth.lastNamePlaceholder")}
            prefix={<HiOutlineUser className="text-placeHolder" />}
          />
        </Form.Item>
      </div>

      {/* Row 2: Email & Phone */}
      <div className="flex gap-4">
        <Form.Item
          name="email"
          label={
            <span className="text-textPrimary text-lg">{t("auth.email")}</span>
          }
          className="flex-1 mb-0"
          rules={[
            { required: true, message: t("auth.emailRequired") },
            { type: "email", message: t("auth.emailInvalid") },
          ]}
        >
          <Input
            placeholder={t("auth.emailAddress")}
            prefix={<HiOutlineMail className="text-placeHolder" />}
          />
        </Form.Item>

        <Form.Item
          name="phoneNumber"
          label={
            <span className="text-textPrimary text-lg">
              {t("auth.phoneNumber")}
            </span>
          }
          className="flex-1 mb-0"
          rules={[
            { required: true, message: t("auth.phoneNumberRequired") },
            {
              pattern: /^[\+]?[0-9][\d]{0,15}$/,
              message: t("auth.phoneNumberInvalid"),
            },
          ]}
        >
          <Input
            placeholder={t("auth.phoneNumberPlaceholder")}
            prefix={
              <GiPhone
                className={`text-placeHolder ${isRTL ? "rotate-180" : ""}`}
              />
            }
          />
        </Form.Item>
      </div>

      <Form.Item
        name="gender"
        label={
          <span className="text-textPrimary text-lg">{t("auth.gender")}</span>
        }
        className="w-full mb-0"
        rules={[{ required: true, message: t("auth.genderRequired") }]}
      >
        <Select
          placeholder={t("auth.genderPlaceholder")}
          className="gender-select"
        >
          <Select.Option value={0}>{t("auth.male")}</Select.Option>
          <Select.Option value={1}>{t("auth.female")}</Select.Option>
        </Select>
      </Form.Item>
      <div className="flex gap-4">
  <Form.Item
    name="dobDay"
    label={
      <span className="text-textPrimary text-lg">
        {t("auth.dob")}
      </span>
    }
    className="flex-1 mb-0"
    rules={[
      {
        required: true,
        message: isRTL ? "اليوم مطلوب" : "Day is required",
      },
    ]}
  >
    <Select listHeight={200} virtual={false}  placeholder={isRTL ? "اليوم" : "Day"}>
      {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
        <Select.Option key={day} value={day}>
          {isRTL?(day).toLocaleString('ar-EG'): day}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>

  <Form.Item name="dobMonth" label=" " className="flex-1 mb-0">
    <Select  listHeight={200} virtual={false} placeholder={isRTL ? "الشهر" : "Month"}>
      {(isRTL
        ? [
            "يناير", "فبراير", "مارس", "أبريل",
            "مايو", "يونيو", "يوليو", "أغسطس",
            "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر",
          ]
        : [
            "January", "February", "March", "April",
            "May", "June", "July", "August",
            "September", "October", "November", "December",
          ]
      ).map((month, index) => (
        <Select.Option key={index + 1} value={index + 1}>
          {month}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>

  <Form.Item name="dobYear" label=" " className="flex-1 mb-0">
    <Select listHeight={200} virtual={false}  placeholder={isRTL ? "السنة" : "Year"}>
      {Array.from(
        { length: 100 },
        (_, i) => new Date().getFullYear() - i,
      ).map((year) => (
        <Select.Option key={year} value={year}>
{isRTL ? year.toLocaleString('ar-EG', { useGrouping: false }) : year}        </Select.Option>
      ))}
    </Select>
  </Form.Item>
</div>

      {/* Row 4: Password & Confirm Password */}
      <div className="flex gap-4">
        <Form.Item
          name="password"
          label={
            <span className="text-textPrimary text-lg">
              {t("auth.password")}
            </span>
          }
          className="flex-1 mb-0"
          rules={[
            { required: true, message: t("auth.passwordCreate") },
            { min: 6, message: t("auth.passwordMinLength") },
            {
              pattern: /^(?=.*[A-Z]*[a-z])(?=.*\d)[A-Za-z\d@$!%*#?&.]{6,}$/,
              message: t("auth.passwordPattern"),
            },
          ]}
        >
          <Input.Password
            placeholder={t("auth.createPassword")}
            prefix={<GiPadlock className="text-placeHolder" />}
          />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label={
            <span className="text-textPrimary text-lg">
              {t("auth.confirmPassword")}
            </span>
          }
          className="flex-1 mb-0"
          dependencies={["password"]}
          rules={[
            { required: true, message: t("auth.confirmPasswordRequired") },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value)
                  return Promise.resolve();
                return Promise.reject(new Error(t("auth.passwordsMismatch")));
              },
            }),
          ]}
        >
          <Input.Password
            placeholder={t("auth.confirmPasswordPlaceholder")}
            prefix={<GiPadlock className="text-placeHolder" />}
          />
        </Form.Item>
      </div>

      <Button
        htmlType="submit"
        loading={loading}
        className="w-full py-3 h-auto text-white text-lg font-semibold bg-primary hover:bg-primary_hover border-none"
      >
        {loading ? t("auth.registering") : t("auth.createAccountBtn")}
      </Button>
    </Form>
  );

  return (
    <Modal
      visible={loginModal}
      onCancel={() => {
        setLoginModal(false);
        setActiveTab("login");
      }}
      footer={null}
      style={{ top: isRegister ? 10 : 60 }}
      bodyStyle={{ padding: "16px", overflowY: "auto", maxHeight: "90vh" }}
      className="responsive-auth-modal w-full md:min-w-[37%]"
    >
      <div className="flex flex-col items-center justify-center w-full">
        <div className="flex overflow-hidden w-full mb-2">
          <p
            className={`w-full  pb-3 font-semibold text-lg transition duration-300 text-primary bg-transparent`}
          >
            {activeTab === "login" ? (
              <p>{t("auth.login")}</p>
            ) : (
              <span className="flex items-center gap-2">
                {" "}
                <button onClick={() => setActiveTab("login")}>
                  {isRTL ? <ArrowRight /> : <BiArrowBack />}{" "}
                </button>{" "}
                {t("auth.signup")}{" "}
              </span>
            )}
          </p>
        </div>

        <div className={`w-full ${shake ? "shake" : ""}`}>
          {activeTab === "login" ? renderLoginForm() : renderSignupForm()}

          {!loginSuccess && (
            <>
              <div className="flex items-center justify-center my-4">
                <div className="flex-grow border-t border-gray-300"></div>
                <span className="px-4 text-gray-500 text-sm font-medium">
                  {t("auth.or")}
                </span>
                <div className="flex-grow border-t border-gray-300"></div>
              </div>
              <div className="flex justify-center items-center w-full">
                <GoogleLogin
                  onSuccess={handleGoogleSignIn}
                  onError={(error) => {
                    message.error(t("auth.googleSignInFailed"));
                  }}
                  size="large"
                  width="100%"
                  text="continue_with"
                  shape="rectangular"
                  locale="ar"
                />
              </div>
            </>
          )}
        </div>
      </div>

      <VerificationModal
        open={showVerificationModal}
        onClose={() => {
          setShowVerificationModal(false);
          setSignupToken("");
        }}
        email={verificationEmail}
        code={verificationCode}
        setCode={setVerificationCode}
        loading={verificationLoading}
        onVerify={handleVerifyCode}
        onResend={handleResendCode}
        resendLoading={resendLoading}
        resendCooldown={resendCooldown}
      />

      <ForgotPasswordModal
        open={showForgotModal}
        onClose={() => setShowForgotModal(false)}
        step={forgotStep}
        email={forgotEmail}
        setEmail={setForgotEmail}
        code={resetCode}
        setCode={setResetCode}
        newPassword={newPassword}
        setNewPassword={setNewPassword}
        loading={resetLoading}
        onSendResetCode={async () => {
          if (!forgotEmail.trim())
            return message.warning(t("auth.emailRequired"));
          setResetLoading(true);
          try {
            await drEasyApi.post(`/api/${slug}/User/ForgotPassword`, {
              email: forgotEmail,
            });
            message.success(t("auth.resetCodeSent"));
            setForgotStep(2);
          } catch (err) {
            if (err.response?.data.errors[0].includes("not found")) {
              message.error(t("auth.emailNotFound"));
            } else {
              message.error(
                err.response?.data.errors[0] || t("auth.sendResetEmailFailed"),
              );
            }
          } finally {
            setResetLoading(false);
          }
        }}
        onResendCode={handleResendResetCode}
        onResetPassword={async () => {
          if (!resetCode.trim() || !newPassword.trim()) {
            return message.warning(t("auth.fillAllFields"));
          }
          setResetLoading(true);
          try {
            await drEasyApi.post(`/api/${slug}/User/ResetPassword`, {
              email: forgotEmail,
              resetCode,
              newPassword,
            });
            message.success(t("auth.passwordResetSuccess"));
            setShowForgotModal(false);
            setActiveTab("login");
          } catch (err) {
            const error =
              err.response?.data?.errors?.[0] || err.response?.data?.message;
            if (!error) {
              message.error(t("auth.passwordResetFailed"));
            } else if (error.includes("Invalid")) {
              message.error(t("auth.invalidVerificationCode"));
            } else if (error.toLowerCase().includes("at least 6")) {
              message.error(t("auth.passwordMinRequirement"));
            } else {
              message.error(error);
            }
          } finally {
            setResetLoading(false);
          }
        }}
      />
    </Modal>
  );
}
